import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AlarmEventTable } from './AlarmEventTable';
import { useAlarmList } from '../useAlarmList';
import { getAlarmRuleErrorMessage } from '../filterParameterMapping';

export const AlarmEventList = ({ isActive = false, onView, alarmEventService, alarmNotificationService: toasterService }) => {
	const [showArchived, setShowArchived] = useState(false);
	const [showHandled, setShowHandled] = useState(true);
	const [showUnhandled, setShowUnhandled] = useState(true);
	const { items, loadBusy, updateItems, mountedRef } = useAlarmList({
		service: alarmEventService,
		isActive,
		showArchived,
		toasterService,
		errorTitle: 'Failed to load alarm events',
	});

	const handleMarkHandled = async alarm => {
		try {
			await alarmEventService.markHandled(alarm.id);
			if (!mountedRef.current) return;
			updateItems(alarms => alarms.map(existingAlarm => (
				existingAlarm.id === alarm.id ? { ...existingAlarm, isHandled: true } : existingAlarm
			)));
			toasterService.success('Alarm marked as handled');
		} catch (error) {
			if (!mountedRef.current) return;
			toasterService.error(
				'Failed to mark alarm event handled',
				getAlarmRuleErrorMessage(error, 'The alarm could not be marked as handled. Please try again.')
			);
		}
	};

	return (
		<AlarmEventTable
			alarms={items}
			isActive={isActive}
			loadBusy={loadBusy}
			showArchived={showArchived}
			onShowArchivedChange={setShowArchived}
			showHandled={showHandled}
			onShowHandledChange={setShowHandled}
			showUnhandled={showUnhandled}
			onShowUnhandledChange={setShowUnhandled}
			onMarkHandled={handleMarkHandled}
			onView={onView}
		/>
	);
};

AlarmEventList.propTypes = {
	isActive: PropTypes.bool,
	onView: PropTypes.func.isRequired,
	alarmEventService: PropTypes.object.isRequired,
	alarmNotificationService: PropTypes.object.isRequired,
};